import { Layout, Crons } from '@/views/scheduler';

export default {
    path: '/scheduler',
    component: Layout,
    children: [
        { path: 'crons', component: Crons },
    ]
};
